export default (str:string):string => {
    let newString = str.replace(/['"\\]+/g, ''); // clear with spec characters
    newString = newString.replace(/\n/gm, ' '); // clear with line breaks
    return newString.replace(/\s\s+/g, ' '); // clear multi spaces
};
